import React from "react";
import { FiMail, FiPhone } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { toast } from "react-toastify";
import { logCrmContactActivity } from "../../utils/crmContactActivity";
import { isContactBlocked } from "../../utils/crmLeadMeta";

const CrmTouchpointBar = ({ lead }) => {
  if (!lead?.id) return null;

  const blocked = isContactBlocked(lead);

  const contact = async (type) => {
    if (blocked) {
      toast.error("Lead is on DND — contact blocked");
      return;
    }
    const result = await logCrmContactActivity(lead.id, type);
    if (result?.blocked) {
      toast.error(result.message || "Contact blocked");
      return;
    }
    if (type === "call" && lead.mobile) {
      window.location.href = `tel:${lead.mobile}`;
    } else if (type === "whatsapp" && lead.mobile) {
      const num = String(lead.mobile).replace(/\D/g, "");
      window.open(`https://wa.me/${num.startsWith("91") ? num : `91${num}`}`, "_blank");
    } else if (type === "email" && lead.email) {
      window.location.href = `mailto:${lead.email}`;
    }
  };

  return (
    <div className="crm-touchpoint-bar">
      <span className="crm-touchpoint-bar__label">Quick touchpoint</span>
      <div className="crm-touchpoint-bar__actions">
        {lead.mobile && (
          <>
            <button type="button" onClick={() => contact("call")} disabled={blocked} title="Call & log">
              <FiPhone size={16} /> Call
            </button>
            <button type="button" onClick={() => contact("whatsapp")} disabled={blocked} title="WhatsApp & log">
              <FaWhatsapp size={16} /> WhatsApp
            </button>
          </>
        )}
        {lead.email && (
          <button type="button" onClick={() => contact("email")} disabled={blocked} title="Email & log">
            <FiMail size={16} /> Email
          </button>
        )}
      </div>
      {blocked && <p className="crm-touchpoint-bar__warn">DND active — outbound contact disabled</p>}
    </div>
  );
};

export default CrmTouchpointBar;
